const styles = {
  divider: {
    height: 1,
    background: '#E8E8E8',
    margin: '0 -25px'
  },
  dividerMobile: {
    margin: '0 -1rem'
  }
}

export default styles
